import { ref } from "vue";
import { SupportLink } from "@/types";

const supportLinks = ref<SupportLink[]>([]);

export { supportLinks };
